import { ClientService, RequestMethod } from '../client-service'
import { RequestResponseLogic } from '../Ui/request-response'

const TEMPLATE = '/notification_template'

export const TemplateLogic = {
    async getTemplates(params) {
        let result = await ClientService.sendRequest(RequestMethod.GET, TEMPLATE, params)
        return await RequestResponseLogic.checkRequestResponse(result)
    },
    async createTemplate(body, params) {
        let result = await ClientService.sendRequestWithBody(RequestMethod.POST, TEMPLATE, params, body)
        return await RequestResponseLogic.checkRequestResponse(result)
    },
    async setTemplate(templateId, body, params) {
        let result = await ClientService.sendRequestWithBody(RequestMethod.PATCH, TEMPLATE + '/' + templateId, params, body)
        return await RequestResponseLogic.checkRequestResponse(result)
    },
    async deleteTemplate(templateId, params) {
        let result = await ClientService.sendRequest(RequestMethod.DELETE, TEMPLATE + '/' + templateId, params)
        return await RequestResponseLogic.checkRequestResponse(result)
    }
}